import { SquareCard } from "./SquareCard";
import { Row } from "./Row";
export class SquareRow extends Row {
    static _template() {
        return Object.assign(Object.assign({}, super._template()), { h: this.H });
    }
    _init() {
        this.tag("Title").patch({ text: { fontFace: "Lato" } });
    }
    createCard(item) {
        return Object.assign(Object.assign({}, super.createCard(item)), { logoSrc: item.logoSrc, type: SquareCard });
    }
}
SquareRow.H = 54 + SquareCard.H;
export default SquareRow;
//# sourceMappingURL=SquareRow.js.map